// aws-sdk v2 (used for direct-to-S3 receipt/file uploads) expects Node globals
// that react-scripts 5 / webpack 5 no longer provide. Without these, calling
// `new AWS.S3()` / `new AWS.CognitoIdentityCredentials()` throws
// "global is not defined" (or "process is not defined") SYNCHRONOUSLY — before
// any network request — which the upload helper caught and surfaced as a generic
// "Failed to upload <file>" with nothing in the network tab.
//
// This module must be imported FIRST (before aws-sdk's module code runs), so the
// shims exist by the time the SDK evaluates. Only defines what's missing.
const globalScope = window as unknown as Record<string, unknown>;

if (!globalScope.global) {
  globalScope.global = window;
}

if (!globalScope.process) {
  // Minimal process shim. CRA statically inlines `process.env.REACT_APP_*` at
  // build time, so this empty env doesn't affect app config — it only satisfies
  // aws-sdk's runtime `process` references.
  globalScope.process = {
    env: {},
    version: "",
    browser: true,
    nextTick: (cb: (...args: unknown[]) => void, ...args: unknown[]) => setTimeout(() => cb(...args), 0)
  };
}

export {};
